import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/useAuth';
import { Spinner } from './Spinner';
import { NotAdminPage } from '../pages/NotAdminPage';
import { rememberPath } from '../lib/keepSignedIn';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { loading, session, isAdmin, adminChecked } = useAuth();
  const location = useLocation();

  if (loading || (session && !adminChecked)) {
    return (
      <div className="center-screen">
        <Spinner label="Checking your access…" />
      </div>
    );
  }
  if (!session) {
    // A deep link opened while signed out: land there after sign-in.
    rememberPath(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  if (!isAdmin) return <NotAdminPage />;
  return <>{children}</>;
}
